import _ from 'lodash'
import classNames from 'classnames'
import { List } from 'immutable'
import React, { Component } from 'react'
import { getSegmentSelection as filterHidden } from 'utils/SegmentSelectHelper'
import { SegmentPreviewLink } from 'components/CampaignWizards/TargetingInputArea/SegmentSelect'
import SegmentOptionRow from 'components/campaign/NewCampaign/SegmentOptionRow'
import {
  AnonymousOption,
  EveryoneOption,
  IdentifiedUsersOption
} from 'components/CampaignWizards/TargetingInputArea/AudienceOption'

import {
  Wrapper as AmbWrapper,
  Button as AmbButton,
  Menu as AmbMenu,
  MenuItem as AmbMenuItem
} from 'react-aria-menubutton'
import { audienceOptions } from './Constants'
import styles from './style.styl'

function getRows(segments, segmentsToHide, users, selectedSegmentId) {
  let selected
  const rows = segments.reduce((result, segment) => {
    const row = (<SegmentOptionRow segment={ segment } author={ users[segment.authorId] }/>)

    if (selectedSegmentId === segment.id) {
      selected = row
    }

    if (segmentsToHide.contains(segment.id)) {
      return result
    }

    return result.push(
      <AmbMenuItem
          key={ segment.id }
          value={ segment.id }
          text={ segment.name }
      >
        { row }
      </AmbMenuItem>
    )
  }, List())

  return { rows, selected }
}

function getSelectedAudienceOption(audience) {
  switch (audience) {
    case "VISITORS":
      return AnonymousOption
    case "EVERYONE":
      return (<EveryoneOption />)
    case "USERS":
      return (<IdentifiedUsersOption />)
    default:
      return "Pick an Audience"
  }
}

class SegmentSelect extends Component {
  render() {
    const {
      index,
      segments,
      audience,
      users,
      onSelection,
      selectedSegmentId,
      segmentsToHide = List(),
    } = this.props

    const nonSegmentOptions = index === 0 ? [<EveryoneOption />, <IdentifiedUsersOption />] : null
    const { rows, selected } = getRows(filterHidden(selectedSegmentId, segments), segmentsToHide, users, selectedSegmentId)
    const selectedOption = selected || getSelectedAudienceOption(audience)

    return (
      <div key="segmentId" className={classNames(styles.SegmentSelect, { "top-select": index === 0 })}>
        {this.renderSegmentActions()}
        <AmbWrapper
            className="AriaMenuButton AriaMenuButton--large"
            onSelection={onSelection}
        >
          <AmbButton>
            <div className="content">{ selectedOption }</div>
          </AmbButton>
          <AmbMenu>
            {nonSegmentOptions}
            {rows}
          </AmbMenu>
        </AmbWrapper>
      </div>
    )
  }

  renderSegmentActions() {
    const { audience, selectedSegmentId, onClear } = this.props
    if (audience === audienceOptions.SEGMENT.key) {
      if (selectedSegmentId) {
        return (
          <div className="select-actions">
            <SegmentPreviewLink segmentId={ selectedSegmentId }/><span className="action-separator">|</span><a onClick={onClear}>Clear</a>
          </div>
        )
      } else {
        return (
          <a className="select-actions" onClick={onClear}>Clear</a>
        )
      }
    }
  }
}

class MultiSegmentSelect extends Component {
  state = {
    numberOfSelects: this.props.selectedSegments.size || 1
  }

  render() {
    const { segments, audience, users, selectedSegments, className } = this.props

    const components = selectedSegments.map((selectedSegmentId, index) => {
      return (
        <SegmentSelect
            index={index}
            audience={audience}
            segments={segments}
            selectedSegmentId={selectedSegmentId}
            segmentsToHide={selectedSegments}
            users={users}
            onSelection={this.handleSelection(index)}
            onClear={this.handleClear(index)}
        />
      )
    })

    return (
      <div className={classNames(styles.MultiSegmentSelect, className)}>
        <div className="dsg-Label--gray">
          Audience
        </div>

        {components}
        {this.renderExtraSelect()}
        {this.renderAddSegment(components.size)}
      </div>
    )
  }

  renderExtraSelect() {
    const { segments, audience, users, selectedSegments } = this.props
    const { numberOfSelects } = this.state

    if (numberOfSelects > selectedSegments.size) {
      const index = numberOfSelects - 1
      return (
        <SegmentSelect
            index={index}
            segments={segments}
            segmentsToHide={selectedSegments}
            audience={audience}
            users={users}
            onSelection={this.handleSelection(index)}
            onClear={this.handleClear(index)}
        />
      )
    }
  }

  renderAddSegment() {
    const { audience, selectedSegments } = this.props
    const { numberOfSelects } = this.state

    if (audience === audienceOptions.SEGMENT.key && numberOfSelects == selectedSegments.size) {
      return (
        <a key="add-segment"
           className="add-segment"
           onClick={this.addSegmentSelect}>
          + Add another segment
        </a>
      )
    }
  }

  addSegmentSelect = () => {
    const { numberOfSelects } = this.state
    this.setState({ numberOfSelects: numberOfSelects + 1 })
  }

  getAudience(value) {
    if (_.isNumber(value)) {
      return audienceOptions.SEGMENT.key
    }
    return value
  }

  handleSelection = (index) => (value) => {
    const { onSelection } = this.props
    const newAudience = this.getAudience(value)

    if (newAudience !== audienceOptions.SEGMENT.key) {
      this.setState({ numberOfSelects: 1 })
    }

    onSelection(newAudience, index, value)
  }

  handleClear = (index) => () => {
    const { onSelection } = this.props
    const { numberOfSelects } = this.state

    if (numberOfSelects === 1) {
      onSelection(audienceOptions.EVERYONE.key)
    } else {
      onSelection(audienceOptions.SEGMENT.key, index)
      this.setState({ numberOfSelects: numberOfSelects - 1 })
    }
  }
}

export default MultiSegmentSelect



// WEBPACK FOOTER //
// ./src/scripts/components/CampaignWizards/TargetingInputArea/MultiSegmentSelect/index.js